import api, { checkTokenErrorResponse } from '..';

function formatBankAccount(bankAccount) {
    return `${bankAccount.banco}, ag. ${bankAccount.agencia}, conta ${bankAccount.numero}`;
}

export async function getBankAccounts() {
    return api.get("contas_bancarias/")
        .then(function (response) {
            // handle success
            return response;
        })
        .catch(function (error) {
            // handle error
            console.log(error);
            if (error.response) {
                console.log(error.response.data);
                checkTokenErrorResponse(error.response);
            }
            return error;
        });
};

export async function postBankAccount(banco, agencia, numero, tipo, moeda,saldo) {
    const formdata = new FormData();

    formdata.append("banco", banco);
    formdata.append("agencia", agencia);
    formdata.append("numero", numero);
    formdata.append("tipo", tipo);
    formdata.append("moeda", moeda);
    formdata.append("saldo", saldo);

    return api.post(`contas_bancarias/`, formdata)
        .then(function (response) {
            // handle success
            return response;
        })
        .catch(function (error) {
            // handle error
            console.log(error);
            if (error.response) {
                console.log(error.response.data);
                checkTokenErrorResponse(error.response);
            }
            return error;
        });
};


export async function getBankAccount(id) {
    return api.get(`contas_bancarias/${id}/`)
        .then(function (response) {
            // handle success
            return response;
        })
        .catch(function (error) {
            // handle error
            console.log(error);
            if (error.response) {
                console.log(error.response.data);
                checkTokenErrorResponse(error.response);
            }
            return error;
        });
};

export async function deleteBankAccount(id) {
    return api.delete(`contas_bancarias/${id}/`)
        .then(function (response) {
            // handle success
            return response;
        })
        .catch(function (error) {
            // handle error
            console.log(error);
            if (error.response) {
                console.log(error.response.data);
                checkTokenErrorResponse(error.response);
            }
            return error;
        });
};


export async function patchBankAccount(id, banco, agencia, numero, tipo, moeda,saldo) {
    const formdata = new FormData();

    formdata.append("banco", banco);
    formdata.append("agencia", agencia);
    formdata.append("numero", numero);
    formdata.append("tipo", tipo);
    formdata.append("moeda", moeda);
    formdata.append("saldo", saldo);

    return api.patch(`contas_bancarias/${id}/`, formdata)
        .then(function (response) {
            // handle success
            return response;
        })
        .catch(function (error) {
            // handle error
            console.log(error);
            if (error.response) {
                console.log(error.response.data);
                checkTokenErrorResponse(error.response);
            }
            return error;
        });
};


const bankAccountServices = {
    getBankAccount,
    getBankAccounts,
    postBankAccount,
    deleteBankAccount,
    patchBankAccount,
    formatBankAccount
}
export default bankAccountServices;